<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <!-- Input nativo oculto -->
  <input
    #fileInput
    type="file"
    class="d-none"
    [accept]="accept"
    [disabled]="isDisabled"
    (change)="onFileSelected($event)"
  >

  <!-- Área de drop / seleção (quando não há arquivo) -->
  <div
    *ngIf="!fileInfo"
    class="is-file-field__dropzone rounded-3 border border-2 text-center p-4"
    [class.is-file-field__dropzone--active]="isDragging"
    [class.is-file-field__dropzone--error]="hasError"
    [class.opacity-50]="isDisabled"
    role="button"
    tabindex="0"
    (click)="openFilePicker()"
    (keydown.enter)="openFilePicker()"
    (keydown.space)="openFilePicker()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <div class="is-file-field__icon-wrapper mb-2">
      <i class="bx bx-cloud-upload"></i>
    </div>
    <p class="mb-1 fw-medium small text-dark">
      {{ 'IS_LIB.FILE_DROP_TEXT' | translate }} <span class="text-primary">{{ 'IS_LIB.FILE_DROP_CLICK' | translate }}</span>
    </p>
    <p class="mb-0 text-muted" style="font-size: 0.75rem;">
      <span *ngIf="acceptedFormatsLabel">{{ 'IS_LIB.FILE_FORMATS' | translate }}: {{ acceptedFormatsLabel }}</span>
      <span *ngIf="acceptedFormatsLabel && maxSizeMb"> · </span>
      <span *ngIf="maxSizeMb">{{ 'IS_LIB.FILE_MAX_SIZE' | translate }} {{ maxSizeMb }}MB</span>
    </p>
  </div>

  <!-- Preview do arquivo selecionado -->
  <div
    *ngIf="fileInfo"
    class="is-file-field__preview d-flex align-items-center rounded-3 border p-3"
  >
    <div class="is-file-field__file-icon me-3">
      <i [class]="'bx ' + fileInfo.icon"></i>
    </div>
    <div class="flex-grow-1 overflow-hidden">
      <p class="mb-0 fw-medium small text-dark text-truncate">{{ fileInfo.name }}</p>
      <p class="mb-0 text-muted" style="font-size: 0.75rem;">{{ fileInfo.size }}</p>
    </div>
    <button
      type="button"
      class="btn btn-sm btn-outline-danger ms-2 rounded-circle is-file-field__remove"
      (click)="removeFile()"
      [attr.aria-label]="'IS_LIB.FILE_REMOVE' | translate"
    >
      <i class="bx bx-x"></i>
    </button>
  </div>

  <!-- Help text -->
  <small *ngIf="helpText && !hasError && !fileInfo" class="form-text text-muted d-block mt-1">
    {{ helpText }}
  </small>

  <!-- Validation error -->
  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
